import { createRequestCallbackModel } from '@cian/api-models/monolith-python/api/callback/add';
import { IHttpApi } from '@cian/http-api';

export interface IRequestCallbackParams {
  customerPhone: string;
  agentPhone: string;
  time: string;
  subdomain: string;
}

export function requestCallback(subdomain: string) {
  return async (httpApi: IHttpApi, parameters: IRequestCallbackParams) => {
    const callRightNow = parameters.time.length === 0;

    const model = createRequestCallbackModel({
      hostType: 'ud-api',
      parameters: {
        ...parameters,
        callRightNow,
      },
    });

    try {
      const { response } = await httpApi.fetch(model, {
        requestConfig: {
          withCredentials: true,
        },
        subdomain,
      });

      return response;
    } catch (error) {
      throw error;
    }
  };
}
